module.exports = __webpack_public_path__ + "static/media/engagements.a481e5ce.svg";